module.exports = __webpack_public_path__ + "static/media/nirma_logo.3d91560c.png";